import React, { useState } from 'react';
import contactService from '../services/contactService';
import { phoneMask } from '../utils/masks';

const Servicos = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [formData, setFormData] = useState({
    company: '',
    address: '',
    email: '',
    phone: '',
    description: ''
  });

  const openQuoteModal = (serviceTitle) => {
    setSelectedService(serviceTitle || '');
    setIsModalOpen(true);
    setSubmitStatus(null);
  };

  const closeQuoteModal = () => {
    setIsModalOpen(false);
    setSelectedService('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === 'phone') {
      newValue = phoneMask(value);
    } else if (name === 'email') {
      newValue = value.toLowerCase();
    }

    setFormData(prev => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const payload = {
        name: formData.company,
        email: formData.email,
        phone: formData.phone,
        subject: `Solicitação de Orçamento - ${selectedService || 'Serviço'}`,
        message: [
          `Serviço: ${selectedService}`,
          `Empresa: ${formData.company}`,
          `Endereço: ${formData.address}`,
          formData.phone ? `Telefone: ${formData.phone}` : null,
          '',
          'Descrição:',
          formData.description
        ].filter(Boolean).join('\n')
      };

      const response = await contactService.sendMessage(payload);
      if (response && response.success) {
        setSubmitStatus('success');
        setFormData({ company: '', address: '', email: '', phone: '', description: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erro ao enviar solicitação de orçamento:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  const services = [
    {
      icon: 'ph-chef-hat',
      title: 'Refeições Preparadas In Loco',
      description: 'Oferecemos soluções completas em alimentação corporativa, produzindo refeições dentro das empresas com infraestrutura própria. Garantimos total segurança alimentar e um rigoroso padrão de qualidade, atendendo integralmente às normas sanitárias e exigências legais.'
    },

    {
      icon: 'ph-truck',
      title: 'Refeições Transportadas',
      description: 'Para empresas sem infraestrutura para produção local, disponibilizamos refeições transportadas com a máxima segurança. As refeições são preparadas em nossa cozinha central e entregues em embalagens térmicas apropriadas (hot boxes), utilizando veículos inspecionados. Todo o processo é supervisionado por nossa equipe de nutricionistas, assegurando a qualidade dos alimentos até o momento do consumo.'
    },

    {
      icon: 'ph-coffee',
      title: 'Coffee Break/ Eventos',
      description: 'Atendemos demandas específicas para coffee breaks, personalizando cada serviço de acordo com as preferências e necessidades do cliente. Nossa equipe elabora um cardápio exclusivo, garantindo sofisticação, qualidade e praticidade para eventos corporativos e reuniões.'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-800 dark:text-white mb-4">
          Nossos Serviços
        </h1>
        <p className="text-xl text-slate-600 dark:text-slate-300 max-w-3xl mx-auto">
          Oferecemos uma gama completa de serviços gastronômicos para atender todas as suas necessidades
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid md:grid-cols-2 gap-8 items-stretch">
        {services.map((service, index) => (
          <div key={index} className="bg-white dark:bg-slate-800 rounded-2xl shadow-lg overflow-hidden group hover:shadow-xl transition-all duration-300 h-full">
            <div className="p-8 flex flex-col h-full">
               <div className="flex items-center mb-6">
                 <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mr-4 group-hover:bg-primary/20 transition-colors">
                   <i className={`ph ${service.icon} text-3xl text-primary`}></i>
                 </div>
                 <h3 className="text-2xl font-bold text-slate-800 dark:text-white">
                   {service.title}
                 </h3>
               </div>
               
               <p className="text-slate-600 dark:text-slate-300 mb-6 leading-relaxed">
                 {service.description}
               </p>
               
               <div className="space-y-3">
                 {/* <h4 className="font-semibold text-slate-800 dark:text-white mb-3">
                   Características:
                 </h4> */}
                 {/* <ul className="space-y-2">
                   {service.features.map((feature, featureIndex) => (
                     <li key={featureIndex} className="flex items-center text-slate-600 dark:text-slate-300">
                       <i className="ph ph-check-circle text-primary mr-3"></i>
                       {feature}
                     </li>
                   ))}
                 </ul> */}
               </div>
               
              <button
                onClick={() => openQuoteModal(service.title)}
                className="mt-auto w-full bg-primary hover:bg-primary/90 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                Solicitar Orçamento
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal de Solicitação de Orçamento */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-[100]" onClick={closeQuoteModal}>
          <div
            className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-600 w-full max-w-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="quoteModalTitle"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-6 bg-gradient-to-r from-primary to-primary-dark text-white">
              <h3 id="quoteModalTitle" className="text-2xl font-bold">Solicitar Orçamento</h3>
              <button onClick={closeQuoteModal} className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors" aria-label="Fechar">
                <i className="ph ph-x text-xl"></i>
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-4">
              <div className="bg-slate-50 dark:bg-slate-700 rounded-lg p-4">
                <span className="text-sm text-slate-600 dark:text-slate-300">Serviço selecionado</span>
                <div className="mt-1 font-semibold text-slate-800 dark:text-white">{selectedService}</div>
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="company" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                      Nome da Empresa *
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-slate-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-slate-700 text-slate-900 dark:text-white"
                      placeholder="Ex: Bondegusto Alimentos Ltda."
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-slate-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-slate-700 text-slate-900 dark:text-white"
                      placeholder="contato@empresa.com.br"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="address" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                      Endereço da Empresa
                    </label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-slate-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-slate-700 text-slate-900 dark:text-white"
                      placeholder="Rua, número, bairro, cidade/UF"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                      Número de Telefone
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="w-full px-4 py-3 border border-slate-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-slate-700 text-slate-900 dark:text-white"
                      placeholder="(11) 99999-9999"
                      maxLength={15}
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="description" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                    Descrição *
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                    rows={6}
                    className="w-full px-4 py-3 border border-slate-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent bg-white dark:bg-slate-700 text-slate-900 dark:text-white resize-none"
                    placeholder="Descreva sua necessidade, quantidade de pessoas, frequência, datas, etc."
                  ></textarea>
                </div>

                {/* Status Messages */}
                {submitStatus === 'success' && (
                  <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 text-green-700 dark:text-green-400 px-4 py-3 rounded-lg">
                    <div className="flex items-center">
                      <i className="ph ph-check-circle text-lg mr-2"></i>
                      <span>Solicitação enviada com sucesso! Entraremos em contato em breve.</span>
                    </div>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400 px-4 py-3 rounded-lg">
                    <div className="flex items-center">
                      <i className="ph ph-warning-circle text-lg mr-2"></i>
                      <span>Erro ao enviar solicitação. Tente novamente.</span>
                    </div>
                  </div>
                )}

                <div className="flex items-center justify-end gap-3 pt-2">
                  <button
                    type="button"
                    onClick={closeQuoteModal}
                    className="px-4 py-2 rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="px-6 py-3 rounded-lg bg-primary text-white font-semibold hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                  >
                    <span>{isSubmitting ? 'Enviando...' : 'Enviar Solicitação'}</span>
                    {isSubmitting ? (
                      <i className="ph ph-spinner-gap text-lg ml-2 animate-spin"></i>
                    ) : (
                      <i className="ph ph-paper-plane-tilt text-lg ml-2"></i>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Servicos;